import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FetchClientData,
  FetchVerification,
  Updateappointmentstatus,
} from "../../api/helper";
import { Store } from "../../redux";
import { setHeaderToken } from "../../redux/cookiesReducer";
import {
  Input,
  Label,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  AlertDescription,
  Alert,
} from "./ReuseableComponent/alert";
import { AlertCircle, Clock } from "lucide-react";

const validationSchema = Yup.object().shape({
  clientID: Yup.string().required("Client ID is required"),
  fullName: Yup.string().required("Full Name is required"),
  dob: Yup.date().required("Date of Birth is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const VerifyIdentity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tokenFromQuery = queryParams.get("t");
  const originalClientData = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [appointmentsdetail, setAppointmentsdetail] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (tokenFromQuery) {
      Store.dispatch(setHeaderToken({ token: tokenFromQuery }));
      handleInitialAPIs();
    }
  }, [tokenFromQuery]);

  const handleInitialAPIs = async () => {
    try {
      const verificationRes = await FetchVerification();
      const isVerified = verificationRes?.data?.data?.isVerify;
      const appointmentData = verificationRes?.data?.data;
      setAppointmentsdetail(appointmentData);

      await GetClientData();

      // Auto-redirect is optional
      // if (isVerified) {
      //   navigate("/VerifyRequiredForms", { state: { originalClient: appointmentData } });
      // }
    } catch (err) {
      console.error("Verification fetch error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const GetClientData = async () => {
    try {
      const res = await FetchClientData();
      const client = res?.data?.data?.patientData;
      if (client) {
        const clientInfo = {
          clientID: client?.clientId || client?.uniqueId || "",
          fullName: `${client?.firstName || ""}${client?.lastName || ""}`,
          dob: client?.DOB ? client.DOB.split("T")[0] : "",
          email: client?.email || "",
        };
        originalClientData.current = clientInfo;
      }
    } catch (err) {
      console.error("Error fetching client data:", err);
    }
  };
  useEffect(() => {
    if (originalClientData.current) {
      reset(originalClientData.current);
    }
  }, [originalClientData.current]);
  console.log(watch())

  const onSubmit = async (data) => {
    const formattedInput = {
      clientID: data.clientID.trim(),
      fullName: data.fullName.trim(),
      dob: moment(data.dob).format("YYYY-MM-DD"),
      email: data.email.trim().toLowerCase(),
    };

    const original = {
      clientID: originalClientData.current?.clientID?.trim(),
      fullName: originalClientData.current?.fullName?.trim(),
      dob: originalClientData.current?.dob?.trim(),
      email: originalClientData.current?.email?.trim().toLowerCase(),
    };

    const isMatch = Object.entries(formattedInput).every(
      ([key, value]) => value === original[key]
    );

    if (isMatch) {
      try {
        await Updateappointmentstatus(
          { isVerify: true },
          appointmentsdetail?.response?._id
        );
        navigate("/VerifyRequiredForms", {
          state: { originalClient: appointmentsdetail },
        });
      } catch (error) {
        console.error("Verification update failed", error);
      }
    } else {
      navigate("/ErrorPage");
    }
  };

  if (isLoading) {
    return <div className="verifyidentity-loading">Loading...</div>;
  }

  return (
    <div className="verifyidentity-wrapper">
      <div className="verifyidentity-container">
        {/* Optional: Countdown */}
        {/* {countdown && (
          <Alert>
            <Clock className="verifyidentity-icon" />
            <AlertDescription className="verifyidentity-alert-description">
              {countdown}
            </AlertDescription>
          </Alert>
        )} */}

        <Card>
          <CardHeader className="verifyidentity-card-header">
            <CardTitle className="verifyidentity-title">
              Verify Your Identity
            </CardTitle>
            <CardDescription className="verifyidentity-description">
              Please enter your details to continue with your patient intake.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit(onSubmit)} className="verifyidentity-form">
              {["clientID", "fullName", "dob", "email"].map((field) => (
                <div key={field} className="verifyidentity-field-group">
                  <Label>
                    {{
                      clientID: "Client ID",
                      fullName: "Full Name",
                      dob: "Date of Birth",
                      email: "Email",
                    }[field]}
                  </Label>
                  <input
                    id={field}
                    type={
                      field === "dob"
                        ? "date"
                        : field === "email"
                          ? "email"
                          : "text"
                    }
                    placeholder={`Enter your ${field}`}
                    {...register(field)}
                    className={`verifyidentity-input ${errors[field] ? "error" : ""
                      }`}
                  />
                  {errors[field] && (
                    <p className="verifyidentity-error-msg">
                      <AlertCircle className="verifyidentity-error-icon" />
                      {errors[field]?.message}
                    </p>
                  )}
                </div>
              ))}

              <Button
                type="submit"
                className="verifyidentity-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Verifying..." : "Verify Identity"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default VerifyIdentity;
